import { Card, Col, DatePicker, Form, Input, Row } from "antd";
import { useWatch } from "antd/es/form/Form";
import dayjs from "dayjs";
import { t } from "i18next";
import React from "react";

type Props = {
  form: any;
};

const Timeline = (props: Props) => {
  const enddateValue = useWatch("enddate", props.form);
  const starteventValue = useWatch("startevent", props.form);

  const timePattern = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

  const handleTimeChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    setValue: (value: string) => void,
  ) => {
    let value = e.target.value;
    value = value.replace(/[^0-9:]/g, "");
    const segments = value.split(":");
    if (segments.length > 3) return;
    if (/^([01]?\d|2[0-3])?(:([0-5]?\d)?)?(:([0-5]?\d)?)?$/.test(value)) {
      setValue(value);
    }
  };

  const disabledEndDate = (current: any) => {
    return props.form.getFieldValue("startdate")
      ? current &&
          current <= dayjs(props.form.getFieldValue("startdate")).startOf("day")
      : true;
  };

  const disabledDate = (current: any) => {
    return (
      current &&
      current < dayjs(props.form.getFieldValue("startdate")).startOf("day")
    );
  };

  const disabledStartDate = (current: any) => {
    return (
      current &&
      current < dayjs(props.form.getFieldValue("startevent")).startOf("day")
    );
  };

  const disabledStartRegis = (current: any) => {
    return (
      current &&
      current < dayjs(props.form.getFieldValue("startregis")).startOf("day")
    );
  };

  const disabledStartEvent = (current: any) => {
    return (
      current &&
      current < dayjs(props.form.getFieldValue("startevent")).startOf("day")
    );
  };

  return (
    <div className="add-task-body-layout">
      <Row gutter={24} style={{ marginTop: 20 }}>
        <div
          style={{
            backgroundColor: "#F3F3F1",
            border: "1px solid #cccccc",
            borderRadius: "8px",
            width: "100%",
            padding: "2rem 24px 4rem 24px",
          }}
        >
          <Row style={{ marginBottom: "1rem" }}>
            <span style={{ fontSize: "16px", fontWeight: "600" }}>
              Timeline
            </span>
          </Row>
          <Row>
            <Row gutter={[16, 16]} style={{ padding: "0 3rem" }}>
              {/*start_event_date*/}
              <Col xs={14} md={7}>
                <Form.Item
                  name="startevent"
                  label={t("start_event_date")}
                  rules={[
                    {
                      required: false,
                      message: "Please input start event !",
                    },
                  ]}
                >
                  <DatePicker style={{ width: "100%" }} inputReadOnly />
                </Form.Item>
              </Col>
              <Col xs={10} md={5}>
                <Form.Item
                  name="timestartevent"
                  label=" "
                  rules={[
                    {
                      required: false,
                      message: "Please input the date of event!",
                    },
                    {
                      pattern: timePattern,
                      message: "กรุณากรอกเวลาในรูปแบบ HH:mm:ss เช่น 12:00:00",
                    },
                  ]}
                >
                  <Input
                    placeholder="HH:mm:ss"
                    maxLength={8}
                    onChange={(e) =>
                      handleTimeChange(e, (value) =>
                        props.form.setFieldsValue({
                          timestartevent: value,
                        }),
                      )
                    }
                  />
                </Form.Item>
              </Col>
              {/* resultdate */}
              <Col xs={14} md={7}>
                <Form.Item
                  name="resultdate"
                  label={t("Result Date")}
                  rules={[
                    {
                      required: false,
                      message: "input date of event pls!!",
                    },
                  ]}
                >
                  <DatePicker
                    placeholder="date"
                    style={{ width: "100%" }}
                    inputReadOnly
                    // disabledDate={disabledEndDate}
                  />
                </Form.Item>
              </Col>
              <Col xs={10} md={5}>
                <Form.Item
                  name="timeresult"
                  label=" "
                  dependencies={["timeend", "enddate", "resultdate"]}
                  rules={[
                    {
                      required: false,
                      message: "Please input the date of result!",
                    },
                    {
                      pattern: timePattern,
                      message: "กรุณากรอกเวลาในรูปแบบ HH:mm:ss เช่น 12:00:00",
                    },
                    // ({ getFieldValue }) => ({
                    //   validator(_, value) {
                    //     const timeend = getFieldValue("timeend");
                    //     const enddate = getFieldValue("enddate");
                    //     const resultdate = getFieldValue("resultdate");

                    //     if (!timeend || !value || !enddate || !resultdate) {
                    //       return Promise.resolve();
                    //     }

                    //     if (
                    //       enddate.isSame(resultdate, "day") &&
                    //       value < timeend
                    //     ) {
                    //       return Promise.reject(
                    //         new Error("เวลาประกาศต้องไม่น้อยกว่าเวลาสิ้นสุด"),
                    //       );
                    //     }

                    //     return Promise.resolve();
                    //   },
                    // }),
                  ]}
                >
                  <Input
                    placeholder="HH:mm:ss"
                    maxLength={8}
                    onChange={(e) =>
                      handleTimeChange(e, (value) =>
                        props.form.setFieldsValue({
                          timeresult: value,
                        }),
                      )
                    }
                  />
                </Form.Item>
              </Col>
              {/* startregis */}
              <Col xs={14} md={7}>
                <Form.Item name="startregis" label={t("start_regis_date")}>
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={disabledStartEvent}
                    inputReadOnly
                  />
                </Form.Item>
              </Col>
              <Col xs={10} md={5}>
                <Form.Item
                  name="timestartregis"
                  label=" "
                  dependencies={["timestartevent", "startevent", "startregis"]}
                  rules={[
                    {
                      required: false,
                      message: "Please input the date of start register!",
                    },
                    {
                      pattern: timePattern,
                      message: "กรุณากรอกเวลาในรูปแบบ HH:mm:ss เช่น 12:00:00",
                    },
                    // ({ getFieldValue }) => ({
                    //   validator(_, value) {
                    //     const timeend = getFieldValue("timeend");
                    //     const enddate = getFieldValue("enddate");
                    //     const awarddate = getFieldValue("awarddate");

                    //     if (!timeend || !value || !enddate || !awarddate) {
                    //       return Promise.resolve();
                    //     }

                    //     if (
                    //       enddate.isSame(awarddate, "day") &&
                    //       value < timeend
                    //     ) {
                    //       return Promise.reject(
                    //         new Error("เวลารับรางวัลต้องไม่น้อยกว่าเวลาสิ้นสุด")
                    //       );
                    //     }

                    //     return Promise.resolve();
                    //   },
                    // }),
                  ]}
                >
                  <Input
                    placeholder="HH:mm:ss"
                    maxLength={8}
                    onChange={(e) =>
                      handleTimeChange(e, (value) =>
                        props.form.setFieldsValue({
                          timestartregis: value,
                        }),
                      )
                    }
                  />
                </Form.Item>
              </Col>
              {/* endregis */}
              <Col xs={14} md={7}>
                <Form.Item
                  name="endregis"
                  label={t("end_regis_date")}
                  rules={[
                    {
                      required: false,
                      message: "Please input end register date !",
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={disabledStartRegis}
                    inputReadOnly
                  />
                </Form.Item>
              </Col>
              <Col xs={10} md={5}>
                <Form.Item
                  name="timeendregis"
                  label=" "
                  dependencies={["timestartregis", "startregis", "endregis"]}
                  rules={[
                    {
                      required: false,
                      message: "Please input the date of end register!",
                    },
                    {
                      pattern: timePattern,
                      message: "กรุณากรอกเวลาในรูปแบบ HH:mm:ss เช่น 12:00:00",
                    },
                    // ({ getFieldValue }) => ({
                    //   validator(_, value) {
                    //     const timeend = getFieldValue("timeend");
                    //     const enddate = getFieldValue("enddate");
                    //     const awarddate = getFieldValue("awarddate");

                    //     if (!timeend || !value || !enddate || !awarddate) {
                    //       return Promise.resolve();
                    //     }

                    //     if (
                    //       enddate.isSame(awarddate, "day") &&
                    //       value < timeend
                    //     ) {
                    //       return Promise.reject(
                    //         new Error("เวลารับรางวัลต้องไม่น้อยกว่าเวลาสิ้นสุด")
                    //       );
                    //     }

                    //     return Promise.resolve();
                    //   },
                    // }),
                  ]}
                >
                  <Input
                    placeholder="HH:mm:ss"
                    maxLength={8}
                    onChange={(e) =>
                      handleTimeChange(e, (value) =>
                        props.form.setFieldsValue({
                          timeendregis: value,
                        }),
                      )
                    }
                  />
                </Form.Item>
              </Col>
              {/* startdate */}
              <Col xs={14} md={7}>
                <Form.Item
                  name="startdate"
                  label={t("Start date")}
                  rules={[
                    {
                      required: false,
                      message: "Please input startdate !",
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={disabledStartDate}
                    inputReadOnly
                  />
                </Form.Item>
              </Col>
              <Col xs={10} md={5}>
                <Form.Item
                  name="timestart"
                  label=" "
                  rules={[
                    {
                      required: false,
                      message: "กรุณากรอกค่าเริ่มต้นงาน",
                    },
                    {
                      pattern: timePattern,
                      message: "กรุณากรอกเวลาในรูปแบบ HH:mm:ss เช่น 12:00:00",
                    },
                    // ({ getFieldValue }) => ({
                    //   validator(_, value) {
                    //     const timestartevent = getFieldValue("timestartevent");
                    //     const startevent = getFieldValue("startevent");
                    //     const startdate = getFieldValue("startdate");

                    //     if (
                    //       !timestartevent ||
                    //       !value ||
                    //       !startevent ||
                    //       !startdate
                    //     ) {
                    //       return Promise.resolve();
                    //     }

                    //     if (
                    //       startevent.isSame(startdate, "day") &&
                    //       value < timestartevent
                    //     ) {
                    //       return Promise.reject(
                    //         new Error("เวลาเริ่มไม่น้อยกว่าเวลาประกาศกิจกรรม"),
                    //       );
                    //     }

                    //     return Promise.resolve();
                    //   },
                    // }),
                  ]}
                >
                  <Input
                    placeholder="HH:mm:ss"
                    maxLength={8}
                    onChange={(e) =>
                      handleTimeChange(e, (value) =>
                        props.form.setFieldsValue({
                          timestart: value,
                        }),
                      )
                    }
                  />
                </Form.Item>
              </Col>
              {/* enddate */}
              <Col xs={14} md={7}>
                <Form.Item
                  name="enddate"
                  label={t("End date")}
                  rules={[
                    {
                      required: false,
                      message: "Please input the date of end date!",
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={disabledDate}
                    inputReadOnly
                  />
                </Form.Item>
              </Col>
              <Col xs={10} md={5}>
                <Form.Item
                  name="timeend"
                  label=" "
                  dependencies={["timestart", "startdate", "enddate"]}
                  rules={[
                    {
                      required: false,
                      message: "Please input the date of event!",
                    },
                    {
                      pattern: timePattern,
                      message: "กรุณากรอกเวลาในรูปแบบ HH:mm:ss เช่น 12:00:00",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const timestart = getFieldValue("timestart");
                        const startdate = getFieldValue("startdate");
                        const enddate = getFieldValue("enddate");

                        if (!timestart || !value || !startdate || !enddate) {
                          return Promise.resolve();
                        }

                        if (
                          startdate.isSame(enddate, "day") &&
                          value < timestart
                        ) {
                          return Promise.reject(
                            new Error("เวลาสิ้นสุดต้องไม่น้อยกว่าเวลาเริ่มต้น"),
                          );
                        }

                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <Input
                    placeholder="HH:mm:ss"
                    maxLength={8}
                    onChange={(e) =>
                      handleTimeChange(e, (value) =>
                        props.form.setFieldsValue({ timeend: value }),
                      )
                    }
                  />
                </Form.Item>
              </Col>
              {/* awarddate */}
              <Col xs={14} md={7}>
                <Form.Item
                  name="awarddate"
                  label={t("Award Date")}
                  rules={[
                    {
                      required: false,
                      message: "input date of event pls!!",
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    placeholder="date"
                    // disabledDate={disabledEndDate}
                    inputReadOnly
                  />
                </Form.Item>
              </Col>
              <Col xs={10} md={5}>
                <Form.Item
                  name="timeaward"
                  label=" "
                  dependencies={["timeend", "enddate", "awarddate"]}
                  rules={[
                    {
                      required: false,
                      message: "Please input the date of event!",
                    },
                    {
                      pattern: timePattern,
                      message: "กรุณากรอกเวลาในรูปแบบ HH:mm:ss เช่น 12:00:00",
                    },
                    // ({ getFieldValue }) => ({
                    //   validator(_, value) {
                    //     const timeend = getFieldValue("timeend");
                    //     const enddate = getFieldValue("enddate");
                    //     const awarddate = getFieldValue("awarddate");

                    //     if (!timeend || !value || !enddate || !awarddate) {
                    //       return Promise.resolve();
                    //     }

                    //     if (
                    //       enddate.isSame(awarddate, "day") &&
                    //       value < timeend
                    //     ) {
                    //       return Promise.reject(
                    //         new Error(
                    //           "เวลารับรางวัลต้องไม่น้อยกว่าเวลาสิ้นสุด",
                    //         ),
                    //       );
                    //     }

                    //     return Promise.resolve();
                    //   },
                    // }),
                  ]}
                >
                  <Input
                    placeholder="HH:mm:ss"
                    maxLength={8}
                    onChange={(e) =>
                      handleTimeChange(e, (value) =>
                        props.form.setFieldsValue({
                          timeaward: value,
                        }),
                      )
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            {/* </Form> */}
          </Row>
        </div>
      </Row>
    </div>
  );
};

export default Timeline;
